export const NodeState = {
    LEADER: 'LEADER',
    FOLLOWER: 'FOLLOWER',
    CANDIDATE: 'CANDIDATE',
    // node without icon
    OUT_OF_SYNC_BLANK: 'OUT_OF_SYNC_BLANK'
};
